<template>
  <div class="relative">
    <div class="py-5 relative lg:bg-gray-50 lg:py-10 lg:rounded-lg">
      <h1 v-if="title" class="ota-body text-center lg:ota-title cursor-pointer" @click="$emit('back')" v-text="title" />
      <SignUpBackButton class="lg:hidden" @back-button-click="$emit('back')" />
      <div class="single-design-background hidden lg:block lg:bg-gray-50 lg:absolute lg:w-full lg:rounded-b-lg" />
    </div>
    <div class="lg:px-24 relative z-10">
      <div class="lg:flex lg:flex-row-reverse lg:rounded-lg lg:shadow-lg">
        <div class="boxer-flex-wrapper lg:flex-1 lg:rounded-r-lg lg:bg-gray-50">
          <div class="boxer-container relative mb-20 lg:rounded-tr-lg" :style="{ 'background-color': design.color }">
            <div class="absolute-image-container absolute w-full h-full z-10">
              <!-- TODO Dynamic alt tag (e.g. Glory men originals boxer short)-->
              <OImage
                img-class="mx-auto"
                :desktop="design.image.desktop"
                :mobile="design.image.mobile"
                :src="design.image.src"
                :alt="$t('Accessibilty.AltTags.Boxershort')"
              />
              <button
                v-if="design.nextDesignSlug"
                class="arrow-left absolute cursor-pointer lg:hidden p-5 focus:outline-none"
                :aria-label="$t('Accessibilty.AriaLabels.NextDesign')"
                @click="$emit('next', design.nextDesignSlug)"
              >
                <OSvg
                  class="h-5 w-5 transform -rotate-180"
                  svg="arrow-right"
                />
              </button>
              <button
                v-if="design.previousDesignSlug"
                class="arrow-right absolute cursor-pointer lg:hidden p-5 focus:outline-none"
                :aria-label="$t('Accessibilty.AriaLabels.PreviousDesign')"
                @click="$emit('previous', design.previousDesignSlug)"
              >
                <OSvg
                  class="h-5 w-5"
                  svg="arrow-right"
                />
              </button>
            </div>
            <div class="curved-div-container overflow-hidden absolute w-full">
              <div class="curved-div" :style="{ 'background-color': design.color }" />
            </div>
          </div>
        </div>
        <div class="px-10 lg:flex-1 lg:flex lg:flex-col lg:rounded-l-lg lg:pt-12 lg:px-24 lg:bg-white">
          <h4 class="ota-body-light mb-2" v-text="design.date" />
          <h4 class="ota-title mb-5" v-text="design.name" />
          <h4 class="custom-line-height ota-body-light mb-2 lg:ota-small-light lg:mb-12 lg:flex-1" v-html="design.description" />
          <div class="hidden mb-10 lg:block">
            <OButton variant="ghost" @click="$emit('click')">
              {{ $t('Lookbook.ReadyToTry') }}
            </OButton>
          </div>
        </div>
      </div>
      <OSvg
        v-if="design.nextDesignSlug"
        class="hidden fill-gray-600 lg-arrow-left absolute h-9 w-9 cursor-pointer lg:block"
        svg="arrow-left"
        @click.native="$emit('next', design.nextDesignSlug)"
      />
      <OSvg
        v-if="design.previousDesignSlug"
        class="hidden fill-gray-600 lg-arrow-right absolute h-9 w-9 cursor-pointer lg:block"
        svg="arrow-right"
        @click.native="$emit('previous', design.previousDesignSlug)"
      />
    </div>
  </div>
</template>

<script>
const SignUpBackButton = () => import('@/components/SignUpBackButton')
const OImage = () => import('@/components/OImage')
const OSvg = () => import('@/components/OSvg')
const OButton = () => import('@/components/OButton')

export default {
  name: 'SingleDesignHero',
  components: {
    OSvg,
    SignUpBackButton,
    OButton,
    OImage
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    design: {
      type: Object,
      required: true,
      validator: value => ['previousDesignSlug', 'nextDesignSlug', 'name', 'date', 'description', 'color', 'image'].every(prop => value.hasOwnProperty(prop))
    }
  }
}
</script>

<style lang="postcss" scoped>
.custom-line-height {
  line-height: 2.38rem;
}

.signup-back-button {
  top: 1.3rem !important;
}

.obutton {
  height: unset;
  min-height: 4rem;
}

.curved-div {
    @apply overflow-hidden relative;
    border-bottom-left-radius: 50% 15rem;
    border-bottom-right-radius: 50% 15rem;
    width: 180%;
    left: -40%;
    height: 15rem;
    margin-top: -10rem;
}

.boxer-container {
  min-height: 24.3rem;
  max-height: 24.3rem;

  .absolute-image-container {
    top: 4.8rem;

    .arrow-left {
      top: 6rem;
      left: 2rem;
    }

    .arrow-right {
      top: 6rem;
      right: 2rem;
    }
  }

  .curved-div-container {
    bottom: -2.5rem;
  }

  @screen xsplus {
    .curved-div-container {
      bottom: -3rem;
    }
  }

  @media (min-width: 792px) {
    .curved-div-container {
      bottom: -4rem;
    }
  }

  .oimage >>> img {
    max-width: 24.4rem !important;
  }
}

@screen lg {
  .curved-div-container {
    bottom: -2.6rem !important;
  }

  .boxer-flex-wrapper {
    min-width: 35.6rem;
    max-width: 35.6rem;
    flex-basis: 35.6rem;
  }

  .single-design-background {
    min-height: 14rem;
  }

  .lg-arrow-right {
    top: 15em;
    right: 3rem;
  }

  .lg-arrow-left {
    top: 15em;
    left: 3rem;
  }
}
</style>
